<template>
  <div class="apps-wrap">
    <div class="apps">我的应用</div>
    <div class="apps-main">
      <div class="app-box" @click="createApp">
        <div class="app-div">
          <div class="add-app app-title"><span class="create-app">+ 创建新应用</span></div>
        </div>
      </div>
      <div class="app-list">

        <div class="app-box" v-for="(item, index) in list" :key="index">
          <div class="app-div">
            <div class="app-title my-apps"><span class="my-app-title" @click="applyInfo(item)"> {{ item.app_name }} </span></div>
            <!-- <div class="del-app-div"><span class="del-app" @click="applyDelete">删除</span></div> -->
          </div>
        </div>
      </div>
    </div>
    <CreateApply :visible="dialogCreateVisible" @refreshList="init" @change="changeCreateAppDialog"></CreateApply>
    <ApplyInfo :visible="dialogInfoVisible" @refreshList="init" @change="changeApplyInfoDialog" ref="ApplyInfo"></ApplyInfo>
    <Dialog width="350px" :visible.sync="dialogAlertVisible" title="删除应用提示" message="确定删除该应用？" dialogType="alert"></Dialog>
  </div>
</template>
<script>
import CreateApply from '@/components/document/user/CreateApply'
import ApplyInfo from '@/components/document/user/ApplyInfo'
import Dialog from '@/components/Dialog'
import { getAppApiList } from '@/api/promotion'
export default {
  name: 'Application',
  components: {
    CreateApply,
    ApplyInfo,
    Dialog
  },
  data() {
    return {
      list: [],
      total: 0,
      list: {},
      dialogCreateVisible: false,
      dialogInfoVisible: false,
      dialogAlertVisible: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getAppApiList().then(response => {
        this.list = response.data.list
      }).catch(error => {
        
      })
    },
    // 创建新应用弹窗
    createApp() {
      this.dialogCreateVisible = true
    },
    // 关闭弹窗（创建新应用弹窗）回调
    changeCreateAppDialog(value) {
      this.dialogCreateVisible = value
    },
    // 应用详情弹窗
    applyInfo(item) {
      this.dialogInfoVisible = true
      this.$refs.ApplyInfo.init(item)
    },
    // 关闭弹窗（应用详情弹窗）回调
    changeApplyInfoDialog(value) {
      this.dialogInfoVisible = value
    },
    // 删除应用
    applyDelete() {
      this.dialogAlertVisible = true
    }
  }
}
</script>
<style scoped>
  .apps-wrap{
    width: 90%;
  }
  .apps-wrap .apps {
    font-weight: bolder;
    font-size: 16px;
  }
  .apps-wrap .apps-main {
    padding: 10px;
  }
  .apps-wrap .apps-main .app-box{
    padding: 10px 5px;
    width: 30%;
    float: left;
  }
  .apps-wrap .apps-main .app-div {
    border-radius: 5px;
    border: 1px solid #CCCCCC;
    height: 90px;
  }
  .apps-wrap .apps-main .app-div .add-app {
    color: #FF6600;
  }
  .apps-wrap .apps-main .app-div .app-title {
    cursor: pointer;
    text-align: center;
    padding: 30px 20px 10px 20px;
    font-size: 15px;
    font-weight: bolder;
  }
  .apps-wrap .apps-main .app-div .my-apps {
    color: #0e90d2;
  }
  .apps-wrap .apps-main .app-div .del-app-div {
    color: #666666;
    cursor: pointer;
    text-align: right;
    padding: 0 15px 5px 0;
    text-decoration: underline;
  }
</style>


// WEBPACK FOOTER //
// src/views/pc/document/user/Application.vue